import * as z from "zod/v4";

export const fastTrackClaim = {
  name: "fastTrackClaim" as const,
  input: z.object({ returnId: z.string(), userId: z.string() }),
  output: z.null(),
};
